import React from 'react';

//Estilos
import './UsersWaitingValidation.css';

//Componentes
import TableContainer from '../table/TableContainer';

function UsersWaitingValidation({ tableData }) {
    return (
        <div className="users_for_validation-container">
            {!tableData.data.length && <h3>No hay usuarios para validar</h3>}
            {tableData.data.length > 0 && (
                <TableContainer tableData={tableData} />
            )}
        </div>
    );
}

export default UsersWaitingValidation;
